<template>
  <!-- 购买/续费弹窗 -->
  <div>
    <dialogModel
      title="代理记账"
      subtitle="（包含服务：工商年报、税务月报、年度税务汇算清缴、员工工资表）"
      :confirmText="confirmText"
      width="720px"
      :visible.sync="VisiblePurchase"
      @handleClose="handleClose"
      @handleOk="handleUnderstand"
    >
      <div class="main-body purchase-body">
        <el-form label-width="112px" class="demo-ruleForm">
          <el-form-item label="企业名称：">
            <div class="company-name-row">
              <span>{{ companyName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="企业类型：">
            <div class="company-name-row">
              <span>
                {{
                  companyType == 0
                    ? "有限公司"
                    : companyType == 1
                    ? "个体户"
                    : companyType == 2
                    ? "子公司"
                    : companyType == 3
                    ? "分公司"
                    : companyType == 4
                    ? "其他"
                    : "--"
                }}
              </span>
            </div>
          </el-form-item>
          <el-form-item
            v-if="Purchase === 0 && ToWhom === 0"
            label="纳税类型："
          >
            <el-radio-group
              v-model="PayTaxesType"
              @change="calculateBookkeepingPrice"
            >
              <el-radio
                v-for="item in Arr"
                :key="'tax-' + item.id"
                :label="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <!-- 给客户购买 / 续费 / 升级：只读展示纳税类型 -->
          <el-form-item
            v-if="
              Purchase === 1 ||
              Purchase === 2 ||
              (Purchase === 0 &&
                ToWhom === 1 &&
                self.creditCode != $store.getters.getCompany.recommendCode)
            "
            label="纳税类型："
          >
            <span>{{
              PayTaxesType == 0 ? "小规模纳税人" : "一般纳税人"
            }}</span>
          </el-form-item>

          <el-form-item v-if="Purchase != 2" label="购买时长：">
            <el-radio-group
              v-model="Duration"
              class="duration-radio-group"
              @change="calculateBookkeepingPrice"
            >
              <el-radio
                v-for="(item, index) in Arr1"
                :key="'duration-' + index + '-' + item"
                :label="item"
                >{{ item }}个月</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="支付方式：">
            <el-radio-group v-model="payType">
              <el-radio
                v-for="item in payTypeArr"
                :key="'pay-' + item.id"
                :label="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="价格：">
            <span class="price-text">￥{{ Price }}</span>
          </el-form-item>

          <el-form-item label="代理月份：">
            <span>{{ proxyStartTime }} ~ {{ proxyEndTime }}</span>
          </el-form-item>

          <el-form-item label="服务时间：">
            <span>{{ startTime }} ~ {{ endTime }}</span>
          </el-form-item>

          <el-form-item label="备注：" class="remark-item">
            <el-input
              type="textarea"
              placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
              v-model="textarea"
              maxlength="1500"
              show-word-limit
              resize="none"
              :autosize="{ minRows: 4, maxRows: 8 }"
            />
          </el-form-item>
        </el-form>
      </div>
    </dialogModel>
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="1"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {
  calculateBookkeepingPrice, //获取平台会员代理记账服务价格 新购/续费/升级
  pay,
  tradeQuery, //订单交易查询
  getBuyProxyMonthsSelect,
  getBuyProxyMonthsSelectByCreditCode,
} from "../../../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "./VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";

export default {
  props: {
    VisiblePurchase: {},
    Purchase: {}, ///0购买1续费2升级
    self: {}, ////企业信息
    ToWhom: {}, //0给自己够买1给代理的公司购买
    PurchaserInfo: {}, //购买方信息
  },
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      PayTaxesType: 0, //纳税类型选中
      Arr1: [
        // { id: 1, name: "12个月", val: 12 },
        // { id: 2, name: "24个月", val: 24 },
        // { id: 3, name: "36个月", val: 36 },
      ], //购买时长选项
      Duration: null, //购买时长选中
      value: true, //自动续费
      textarea: "", //备注
      VisiblePayment: false, //付款弹窗
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证

      startTime: "", //服务开始时间
      endTime: "", //服务结束时间
      Price: "", //价格
      companyName: "", //企业名
      companyType: "", //企业类型
      proxyEndTime: "",
      proxyStartTime: "",
    };
  },
  watch: {
    // // // 监听
    VisiblePurchase: {
      handler(newSs, old) {
        if (newSs == true) {
          this.getBuyProxyMonthsSelect();
          setTimeout(() => {
            if (this.Purchase == 2) {
              this.PayTaxesType = 1;
              if (this.ToWhom == 0) {
                this.companyType = this.self.customerCompanyType;
                this.companyName = this.self.companyName;
                this.calculateBookkeepingPrice();
              } else {
                this.companyType = this.self.companyType;
                this.companyName = this.self.companyName;
                this.calculateBookkeepingPrice();
              }
            } else {
              if (this.ToWhom == 0) {
                // 续费给自己：回显客户原纳税类型
                if (this.Purchase == 1) {
                  const t =
                    this.self.customerTaxType ??
                    this.self.taxType ??
                    this.self.orderTaxType;
                  if (t === 0 || t === 1 || t === "0" || t === "1") {
                    this.PayTaxesType = Number(t);
                  }
                }
                this.companyType = this.self.customerCompanyType;
                this.companyName = this.self.companyName;
                this.calculateBookkeepingPrice();
              } else {
                this.PayTaxesType = this.self.taxType;
                this.companyType = this.self.companyType;
                this.companyName = this.self.companyName;
                this.calculateBookkeepingPrice();
              }
            }
          }, 500);
        } else {
          this.Duration = this.Arr1[0]; //购买时长选中
          this.payType = DEFAULT_PAYMENT_METHOD;
          // this.payType = "WECHAT_PAY";
          // this.alipayForm = ``;
          // this.businessType = "";
          // this.payMethod = "";
          // this.orderId = "";
          this.PayTaxesType = 0;
          // this.startTime = ""; //服务开始时间
          // this.endTime = ""; //服务结束时间
          this.Price = ""; //价格
          // this.companyName = ""; //企业名
          // this.companyType = ""; //企业类型
          // // this.Duration = null; //购买时长选中
          this.textarea = ""; //备注
        }
      },
      immediate: false,
    },
  },
  computed: {
    confirmText() {
      return this.Purchase == 2 ? "升级" : this.Purchase == 1 ? "续费" : "购买";
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取可购买时长：客户管理(ToWhom=1)按信用代码；给自己买仍用原接口
    getBuyProxyMonthsSelect() {
      if (this.ToWhom == 1) {
        const creditCode = this.self && this.self.creditCode;
        if (!creditCode) {
          this.Arr1 = [];
          this.Duration = null;
          return;
        }
        API.getBuyProxyMonthsSelectByCreditCode({ data: creditCode }).then(
          (res) => {
            if (res.code == 0) {
              this.Arr1 = res.data;
              this.Duration = res.data[0];
            }
          }
        );
        return;
      }
      API.getBuyProxyMonthsSelect({ data: {} }).then((res) => {
        if (res.code == 0) {
          this.Arr1 = res.data;
          this.Duration = res.data[0];
        }
      });
    },
    //获取平台会员代理记账服务价格 新购/续费/升级
    calculateBookkeepingPrice() {
      if (this.PayTaxesType == 0 || this.PayTaxesType == 1) {
        var data = {
          data: {
            proxyBuyType: this.Purchase, //方式0购买1续费2升级
            creditCode:
              this.ToWhom == 0
                ? this.self.customerCreditCode
                : this.self.creditCode, //公司信用代码
            companyType: this.companyType, //公司类型
            taxType: this.Purchase == 2 ? "1" : this.PayTaxesType, //纳税类型
            monthCount: this.Duration, //月数
            // addressCode: "", //地址编码
          },
        };
        API.calculateBookkeepingPrice(data).then((res) => {
          // if (res.code == 0) {
          this.startTime = res.data.startTime;
          this.endTime = res.data.endTime;
          this.Price = res.data.price;
          this.proxyEndTime = res.data.proxyEndTime;
          this.proxyStartTime = res.data.proxyStartTime;

          // }else{
          //   this.$emit("handleClose");
          // }
        });
      }
    },

    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
      this.$bus.$emit("refresh-company-customers");
    },
    // 取消
    handleClose() {
      this.$emit("handleClose");
    },
    // 确认
    handleUnderstand() {
      if (localStorage.getItem("PaymentPwd") == "false") {
        //没有开启支付密码验证直接弹支付二维码
        this.handleUnderstandPwd();
      } else {
        // 支付密码验证
        this.VisiblePwd = true;
      }
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      var data = {
        data: {
          businessType: "AGENT_ACCOUNTING",
          payMethod: this.payType,
          password: pwd,
          businessInfo: {
            orderType: this.Purchase, //订单类型
            buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
            buyCompanyPhone: this.PurchaserInfo.phone, //购买企业电话
            buyCompanyName: this.PurchaserInfo.companyName,
            buyCompanyCreditCode: this.PurchaserInfo.customerCreditCode,
            orderCompanyName: this.companyName, //订单企业名称
            orderCreditCode:
              this.ToWhom == 0
                ? this.self.customerCreditCode
                : this.self.creditCode, //订单企业信用代码
            orderCompanyType: this.companyType, //公司类型
            orderCompanyPhone: this.self.phone, //服务企业电话
            orderCompanyLegalPerson: this.self.legalPerson, //订单公司法人
            orderTaxType: this.PayTaxesType, //纳税类型
            monthCount: this.Duration, //购买月数
            note: this.textarea,
          },
        },
      };

      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false; //关闭密码验证弹窗
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;

          this.VisiblePayment = true; //打开二维码弹窗
        } else {
          this.VisiblePwd = false; //关闭密码验证弹窗
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.purchase-body {
  max-width: 640px;
  margin: 0 auto;
  padding: 0 10px 8px;
  box-sizing: border-box;

  /* 固定标签列，内容左对齐 */
  /deep/ .el-form-item {
    display: flex !important;
    align-items: flex-start;
    margin-bottom: 12px !important;
    width: 100%;
    box-sizing: border-box;
  }
  /deep/ .el-form-item__label {
    float: none !important;
    width: 112px !important;
    flex: 0 0 112px !important;
    padding: 0 12px 0 0 !important;
    box-sizing: border-box !important;
    text-align: right !important;
    line-height: 36px !important;
    white-space: nowrap !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
    flex: 1 1 auto !important;
    min-width: 0;
    width: auto !important;
    line-height: 36px !important;
    text-align: left !important;
    padding-bottom: 0 !important;
  }
  /deep/ .el-radio-group {
    display: flex !important;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    line-height: 36px;
    max-width: 100%;
  }
  /deep/ .el-radio {
    margin-right: 16px;
    margin-bottom: 0;
    line-height: 36px;
    white-space: nowrap;
  }
  /deep/ .el-radio__label {
    padding-left: 6px;
    font-size: 14px;
    color: #333333;
  }
}
.company-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  line-height: 36px;
}
.Nature {
  min-width: 50px;
  height: 18px;
  line-height: 18px;
  padding: 0 8px;
  font-size: 12px;
  background: #409eff;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
}
.duration-radio-group {
  display: flex !important;
  flex-wrap: wrap !important;
  white-space: normal !important;
  max-width: 100% !important;
  gap: 6px 0;
}
.price-text {
  color: #fe574a;
  font-size: 16px;
}
.remark-item {
  /deep/ .el-textarea {
    width: 100% !important;
    max-width: 100%;
  }
  /deep/ .el-textarea__inner {
    width: 100% !important;
  }
}
</style>
